module.exports = __webpack_public_path__ + "static/img/postnew.71648e64.png";